import table4 from "../../../../assets/images/table/table4x4.png";
import table6 from "../../../../assets/images/table/table6x6.png";
// import grass from "../../../../assets/images/table/grass.png";

export const Table = () => [
  { id: 1, name: "Table 4", type: "table", image: table4 },
  { id: 2, name: "Table 6", type: "table", image: table6 },
  // { id: 3, name: "grass", type: "decoration", image: grass },
];
